import React, { useEffect, useContext, useRef } from 'react';
import './LatestCheckIn.css';
import convenienceApi from '../../common/api/convenience';
import Card from '../Card/Card';
import CardContent from '../Card/CardContent';
import CardLink from '../Card/CardLink';
import CardLinkNotes from '../Card/CardLinkNotes';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { CheckinContext } from '../../contexts/CheckinContext';
import { CardLatestCheckInContext } from '../../contexts/CardLatestCheckInContext';
import LatestCheckInContent from './LatestCheckInContent';
import LatestCheckInLoadingStatus from './LatestCheckInLoadingStatus';
import logComponent from '../../common/logComponent';

export default function LatestCheckIn({ moduleDescription }) {
  const environmentContext = useContext(EnvironmentContext);
  //Note:  We are using context for data and time range because it wasn't updating the CardContent children when data changed or current time stamp changed
  const cardLatestCheckInContext = useContext(CardLatestCheckInContext);
  const checkinContext = useContext(CheckinContext);
  const { hasToken, selectedMonitoredIndividual, selectedUnit, activeUser: user } = environmentContext;
  const loadingRef = useRef(false);

  if (logComponent('LatestCheckIn')) { console.debug('LatestCheckIn rendered'); }

  const setLoadingRef = (el) => {
    if (logComponent('LatestCheckIn')) { console.debug('LatestCheckIn setLoadingRef'); }
    loadingRef.current = el;
  }


  useEffect(() => {
    if (logComponent('LatestCheckIn')) {console.debug('LatestCheckIn onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!hasToken) return;

    loadCheckIn();
  }, []);

  useEffect(() => {
    if (logComponent('LatestCheckIn')) {console.debug('LatestCheckIn useEffect [hasToken, refreshData, environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]'); }
    if (!hasToken) return;

    loadCheckIn();
  }, [hasToken, environmentContext.selectedMonitoredIndividual, environmentContext.activeUser, environmentContext.selectedUnit, checkinContext.mostRecentCheckinCompletionTime]);


  const loadCheckIn = () => {
    if (logComponent('LatestCheckIn')) {console.debug('LatestCheckIn loadCheckIn'); }
    if (!hasToken || loadingRef.current) return;
    setLoadingRef(true);

    const { setLatestCheckIn, setLatestCheckInLoading, setLatestCheckInError } = cardLatestCheckInContext;

    // This will prevent errors for users (Corporate, Status, or Facility w/o 
    // selectedMI) for whom the Latest Check-In module is not intended 
    if (!selectedMonitoredIndividual && !selectedUnit) {
      setLatestCheckInLoading(false);
      setLatestCheckInError(true);

      return;
    }

    setLatestCheckIn(null);
    setLatestCheckInLoading(true);
    setLatestCheckInError(false);

    let unitOrMI = selectedMonitoredIndividual || selectedUnit;

    convenienceApi.getLatestCheckin(unitOrMI)
      .then(
        results => {
          setLatestCheckIn(results);
          setLatestCheckInLoading(false);
          setLatestCheckInError(false);
          setLoadingRef(false);

        },
        error => {
          setLatestCheckIn(null);
          setLatestCheckInLoading(false);
          setLatestCheckInError(true);
          setLoadingRef(false);
        }
      );
  }


  return (
    <Card className="Latest-Checkin" title="Latest check in" moduleDescription={moduleDescription} icon="clipboard-check">
      <CardContent>
        <LatestCheckInContent />
        <LatestCheckInLoadingStatus reloadAction={ loadCheckIn } />
      </CardContent>
      <CardLink>
        <CardLinkNotes />
      </CardLink>
    </Card>
  );
}